import { trackGACustomEvent } from '../common'
import { GA_TRACK_CATEGORY } from '../constants'
import { INavigationMenu } from '../interfaces/analyticsInterfaces'

const EVENT_OPEN = 'open_menu'
const EVENT_CLOSE = 'close_menu'
const EVENT_CLICK_ITEM = 'click_item_menu'

export const NavigationMenu: INavigationMenu = {
  trackMenuOpen: (isOpen: boolean) => {
    trackGACustomEvent({
      category: GA_TRACK_CATEGORY.NAVIGATION_MENU,
      action: isOpen ? EVENT_OPEN : EVENT_CLOSE,
    })
  },

  trackMenuLink: (titleLink: string) => {
    trackGACustomEvent({
      category: GA_TRACK_CATEGORY.NAVIGATION_MENU,
      action: EVENT_CLICK_ITEM,
      label: `Navigate to ${titleLink}`,
    })
  },
}
